import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { LanguageService } from 'src/app/core/services/language.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { SvgIconComponent } from '../../components/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { RouterLinkDirective } from 'ngx-unificator/directives';
import { GlobalEventsService } from '../../../services/global-events.service';
import { PwaService } from '../../../services/pwa.service';
import { PlatformService } from 'ngx-unificator/services';

@Component({
  selector: 'app-header-simple',
  templateUrl: './header-simple.component.html',
  styleUrls: ['./header-simple.component.scss'],
  imports: [
    SvgIconComponent,
    RouterLink,
    RouterLinkDirective
  ],
})
export class HeaderSimpleComponent implements OnInit {

  public lang = inject(LanguageService);
  public user = inject(UserService);
  private _events = inject(GlobalEventsService);
  private _pwa = inject(PwaService);
  private _platform = inject(PlatformService);

  public hideCloseIcon  = input<boolean>(false);
  public isAndroid = signal<boolean>(null);
  public isNotFixedHeader = computed(() => this._events.isRegisterPage() && this.isAndroid() && this._pwa.isThirdPartyView());

  public title = input('');

  ngOnInit() {
    if (this._platform.isBrowser) {
      this.isAndroid.set(/Android/i.test(navigator.userAgent));
    }
  }
}
